export function dimensionValue(value?: string | number | null) {
  if (typeof value === 'number') {
    return `${value}px`;
  }
  if (!value) {
    return undefined;
  }
  return value;
}
